import React from 'react';
import styles from './ConfirmAlert.module.css';
import information from "../../../assets/information-circle.png";

interface ConfirmAlertProps {
    message: string; //메세지
    onConfirm: () => void; //확인 시 실행 함수
    onCancel: () => void; //취소 시 실행 함수
}

//확인창
const ConfirmAlert: React.FC<ConfirmAlertProps> = ({message, onConfirm, onCancel}) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.titleWrapper}>
                        <img src={information} alt="confirm icon" className={styles.logo}/>
                        {/*메세지*/}
                        <h2 className={styles.title}>{message}</h2>
                    </div>
                    <div className={styles.buttonWrapper}>
                        {/*취소 버튼*/}
                        <button
                            className={styles.dismissButton}
                            onClick={onCancel}
                        >
                            취소
                        </button>
                        {/*확인 버튼*/}
                        <button
                            className={styles.dismissButton}
                            onClick={onConfirm}
                        >
                            확인
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmAlert;